import GATSBY_COMPILED_MDX from "C:/Users/Owner/Documents/gatsby/i/content/blog/kakuyomu index correct/index.md";
import * as React from "react";
import {Link, graphql} from "gatsby";
import Bio from "../components/bio";
import Layout from "../components/layout";
import Seo from "../components/seo";
import Share from "../components/share";
import kebabCase from "lodash/kebabCase";
const BlogPostTemplate = ({data: {previous, next, site, mdx: post}, location, children}) => {
  const siteTitle = site.siteMetadata?.title || `Title`;
  const tags = post.frontmatter.tags;
  return React.createElement(Layout, {
    location: location,
    title: siteTitle
  }, React.createElement("article", {
    className: "blog-post",
    itemScope: true,
    itemType: "http://schema.org/Article"
  }, React.createElement("header", null, React.createElement("h1", {
    itemProp: "headline"
  }, post.frontmatter.title), React.createElement("p", null, post.frontmatter.date, "　", tags && tags.length > 0 && tags.map(tag => {
    return React.createElement(Link, {
      to: `/tags/${kebabCase(tag)}/`,
      itemProp: "url"
    }, React.createElement("button", null, tag));
  }))), React.createElement("section", {
    itemProp: "articleBody"
  }, children), React.createElement("hr"), React.createElement(Share, {
    title: post.frontmatter.title,
    url: `${site.siteMetadata.siteUrl}${post.fields.slug}`
  }), React.createElement("footer", null, React.createElement(Bio))), React.createElement("nav", {
    className: "blog-post-nav"
  }, React.createElement("ul", {
    style: {
      display: `flex`,
      flexWrap: `wrap`,
      justifyContent: `space-between`,
      listStyle: `none`,
      padding: 0
    }
  }, React.createElement("li", null, previous && React.createElement(Link, {
    to: previous.fields.slug,
    rel: "prev"
  }, "← ", previous.frontmatter.title)), React.createElement("li", null, next && React.createElement(Link, {
    to: next.fields.slug,
    rel: "next"
  }, next.frontmatter.title, " →")))));
};
export const Head = ({data: {mdx: post}}) => {
  return React.createElement(Seo, {
    title: post.frontmatter.title,
    description: post.frontmatter.description || post.excerpt,
    ogpimage: post.frontmatter.ogpimage
  });
};
BlogPostTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    mdx(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      frontmatter {
        title
        date(formatString: "YYYY年MM月DD日")
        description
        ogpimage
        tags
      }
      fields{
      slug
      }
    }
    previous: mdx(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: mdx(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`;
